import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";
import { Loading } from "common/pages";
import CardThumb from "../CardThumb";
import "./Favorite.scss";

export default function Favorite({ api, account, setAccount }) {

  const [loading, setLoading] = useState(false);

  const [favorites, setFavorites] = useState([]);
  const [limitFavorites, setLimitFavorites] = useState(6);
  const [dataSize, setDataSize] = useState(1);

  useEffect(() => {
    setLoading(true)
    api(`api/providers/${process.env.REACT_APP_SLUG}/content-videos/favorites/?page=1&page_size=${limitFavorites}`)
      .then(({ ok, body }) => {
        if(ok) {
          setFavorites(body.data)
          setDataSize(body.data_size)
        }
        setLoading(false)
      })
  }, [api, limitFavorites, setFavorites])

  const callbackFavorite = {
    unFavorited: (cardId) => {
      setFavorites(prev => prev.filter((cardItem) => cardItem.id !== cardId))
      setAccount(({ ...account, favorite_count: account.favorite_count - 1 }))
    },
  }

  return (
    <>
      {!loading ? (
        <div className="favorite">
          {favorites && favorites.length ? (
            <>
              <div className="bw-event-row">
                {favorites.slice(0, limitFavorites).map((favorite, key) => (
                  <div className="bw-event-col" key={key}>
                    <CardThumb api={api} logged={!!account} card={favorite} callbackFavorite={callbackFavorite} />
                  </div>
                ))}
              </div>

              {limitFavorites < dataSize ? (
                <button
                  className="bw-event-btn bw-event-btn-more"
                  onClick={() => setLimitFavorites(limitFavorites + 3)}
                >
                  Show more
                  <FontAwesomeIcon icon={faChevronRight} style={{ color: "#1976D2" }} />
                </button>
              ) : null}
            </>
          ) : <h3 style={{ marginTop: "30px" }}> Not items found </h3>}
        </div>  
      ) : <Loading className="favorite-loading" />}
    </>
  );
}
